import { getSelectionStore } from '@tunasong/editor'
import type { TunaEditor } from '@tunasong/plugin-lib'
import { useMusicContext } from '@tunasong/redux'
import { useEffect } from 'react'
import { collectCommentedBlocks } from './commented-blocks.js'
import { publishOpenDocument } from './open-document-store.js'
import { showBlockComments } from './show-block-comments.js'

/**
 * Chat makeover M3 (#2718, plan D2): the open song publishes its commented blocks, so the sidebar Chat can group
 * their threads, and a "Show in song" that opens one. Mounted once per editor, by the comment plugin's Root.
 */
export const usePublishCommentedBlocks = (editor: TunaEditor) => {
  const entityId = editor.rootElement?.id
  const [transpose = 0] = useMusicContext({
    editorId: editor.id,
    selector: state => state.transpose ?? 0,
  })

  useEffect(() => {
    if (!entityId) {
      return
    }
    const showInSong = (blockId: string) => {
      showBlockComments(editor, blockId)
    }
    let unpublish = () => {}
    /** The store's change events include cursor moves; the walk only reruns when the document changed */
    let walked: unknown = null
    const publish = () => {
      if (walked === editor.children) {
        return
      }
      walked = editor.children
      unpublish = publishOpenDocument(entityId, {
        blocks: collectCommentedBlocks(editor.children, { transpose }),
        showInSong,
      })
    }
    publish()
    const unsubscribe = getSelectionStore(editor).subscribe(publish)
    return () => {
      unsubscribe()
      unpublish()
    }
  }, [editor, entityId, transpose])
}
